module.exports = __webpack_public_path__ + "img/layout-public-header-bg.a745d39d.png";